import React, { useCallback } from 'react';

const useWebEngage = () => {
    const webEngage = (window as any)?.webengage;

    const logWebEngage = useCallback(
        (event, eventProps) => {
            const { eventName, category = '' } = event || {};
            webEngage?.track(eventName, {
                category: category ?? '',
                ...eventProps,
                module: process.env.REACT_APP_POD_NAME,
            });
        },
        [webEngage],
    );

    return { webEngage, logWebEngage };
};

export default useWebEngage;
